module.exports = __webpack_public_path__ + "static/media/arles_cryptoporticus_tn.55b9a38e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/arles_cryptoporticus_tn.jpg
// module id = 706
// module chunks = 0